import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';

/**
 * @description
 * Get subcategories from specific category
 *
 * @param {Array} categories - All categories.
 * @param {Object} appliedFilter - Applied filters.
 * @returns {Array} - Subcategories.
 */
const getSubCategories = (categories, appliedFilter) => {
  const subCategories = [];
  const category = categories.find(elem => elem.id === appliedFilter.category);
  if (category) {
    category.subcategories.map(subcategory => subCategories.push(subcategory));
  }
  return subCategories;
};

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Component props.
 */
const CategorySelect = props => {
  const { classes, appliedFilter, changeFilter, categories, t } = props;
  const subcategories = getSubCategories(categories, appliedFilter);
  return (
    <div>
      <Select
        data-cy="adsFilterCategorySelect"
        id="select-category"
        className={classes.categoryDD}
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={
          appliedFilter.category === undefined ? 0 : appliedFilter.category
        }
        onChange={e => {
          const { value } = e.target;
          changeFilter({
            category: value !== 0 ? value : undefined,
            subcategory: undefined,
          });
        }}
        inputProps={{
          name: 'selectCategory',
          id: 'selectCategory',
        }}
      >
        <MenuItem
          key="select-category-all"
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value={0}
        >
          {t('common.all')}
        </MenuItem>
        {categories.map(category => (
          <MenuItem
            id={`select-categories-${category.id}`}
            key={`select-categories-${category.id}`}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value={category.id}
          >
            {category.title}
          </MenuItem>
        ))}
      </Select>
      {appliedFilter.category > 0 && (
        <Select
          data-cy="adsFilterSubcategorySelect"
          className={classes.categoryDD}
          MenuProps={{
            className: classes.selectMenu,
          }}
          classes={{
            select: classes.select,
          }}
          value={
            appliedFilter.subcategory === undefined
              ? 0
              : appliedFilter.subcategory
          }
          onChange={e => {
            const { value } = e.target;
            changeFilter({
              subcategory: value !== 0 ? value : undefined,
            });
          }}
          inputProps={{
            name: 'selectSubcategory',
            id: 'selectSubcategory',
          }}
        >
          <MenuItem
            key="select-subcategory-all"
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value={0}
          >
            {t('common.all')}
          </MenuItem>
          {subcategories.map(subcategory => (
            <MenuItem
              id={`select-subcategories-${subcategory.id}`}
              key={`select-subcategories-${subcategory.id}`}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={subcategory.id}
            >
              {subcategory.title}
            </MenuItem>
          ))}
        </Select>
      )}
    </div>
  );
};

/**
 * CategorySelect PropTypes
 * @param classes - prop styles received from withStyles
 * @param appliedFilter - prop to know selected category and subcategory
 * @param categories - prop categories received from parent
 * @param t - prop from HOC with string translations
 * @callback changeFilter - callback called when selected category
 * or subcategory change
 */

CategorySelect.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  categories: PropTypes.instanceOf(Array).isRequired,
  changeFilter: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(FilterStyles)(CategorySelect));
